import React, {Component} from 'react';
import css from './banner.scss';
// import Search from '../search/search';
import {NavLink} from 'react-router-dom';
import {withRouter} from 'react-router';

class Banner extends Component {
	render() {
		return (
			<div className={css.banner}>
				<NavLink
					to="/utilisateurs"
					className={css.link}
					activeClassName="on"
				>
					Utilisateurs
				</NavLink>
				<NavLink
					to="/groupes"
					className={css.link}
					activeClassName="on"
				>
					Groupes
				</NavLink>
				{/* <Search /> */}
			</div>
		);
	}
}

export default withRouter(Banner);



// WEBPACK FOOTER //
// ./src/banner/banner.js